import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings/settings.component';
import { TankProfilesComponent } from './tank-profiles/tank-profiles.component';
import { FilterProfilesComponent } from './filter-profiles/filter-profiles.component';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TankProfileSettingsComponent } from '@components/tank-profile-settings/tank-profile-settings.component';
import { SettingsDialogService } from './services/settings-dialog.service';
import { FilterProfileSettingsComponent } from '@components/filter-profile-settings/filter-profile-settings.component';
import { ProfileSelectorComponent } from './profile-selector/profile-selector.component';
import { ProfileSettingsTabDisplayComponent } from './profile-settings-tab-display/profile-settings-tab-display.component';

@NgModule({
  declarations: [
    SettingsComponent,
    TankProfilesComponent,
    FilterProfilesComponent,
    TankProfileSettingsComponent,
    FilterProfileSettingsComponent,
    ProfileSelectorComponent,
    ProfileSettingsTabDisplayComponent,
  ],
  providers: [SettingsDialogService],
  exports: [SettingsComponent],
  imports: [
    SharedModule,
    CommonModule,
    // SettingsRoutingModule,
    ReactiveFormsModule,
  ],
})
export class SettingsModule {}
